<template>
  <TemplateModal
    ref="modal"
    center
    width="910"
    :text="{
      button: {
        open: t.dialogs['button-create'],
        create: t.dialogs['button-create'],
      },
      title: {
        create: t.dialogs[type === 'manual' ? 'manual-create' : 'triggered-create'],
        edit: t.dialogs[type === 'manual' ? 'manual-edit' : 'triggered-edit'],
        show: t.dialogs[type === 'manual' ? 'manual-show' : 'triggered-show'],
      },
    }"
    :sendFunction="onCreatePush"
    :modalType="modalType"
  >
    <div class="form_wrap">
      <div class="form_wrap-col">
        <BaseInput
          v-model="title"
          :label="t.main['theme']"
          :view="modalType === 'show'"
          :rules="['required']"
        />
        <v-menu offset-y v-if="type === 'projects'">
          <template v-slot:activator="{ on, attrs }">
            <BaseButton
              minimalize
              v-bind="attrs"
              v-on="on"
              default_icon="button-add"
              :text="t.main['add_variable']"
            />
          </template>
          <v-list>
            <template v-for="(item, index) in projectVariableList">
              <div
                class="list-item f14"
                :key="index"
                @click="onAddVariable({ type: 'title', value: item.value })"
              >
                {{ item.text }}
              </div>
            </template>
          </v-list>
        </v-menu>
        <BaseInput
          v-model="body"
          :label="t.main['body']"
          type="textarea"
          :counter="255"
          :view="modalType === 'show'"
          :rules="['required']"
        />
        <v-menu offset-y v-if="type === 'projects'">
          <template v-slot:activator="{ on, attrs }">
            <BaseButton
              minimalize
              v-bind="attrs"
              v-on="on"
              default_icon="button-add"
              :text="t.main['add_variable']"
            />
          </template>
          <v-list>
            <template v-for="(item, index) in projectVariableList">
              <div
                class="list-item f14"
                :key="index"
                @click="onAddVariable({ type: 'body', value: item.value })"
              >
                {{ item.text }}
              </div>
            </template>
          </v-list>
        </v-menu>
        <BaseInput
          v-if="modalType !== 'show' && type === 'projects'"
          :label="
            localStorage.translations.pages.common.text.to_all +
            ' ' +
            t.main['projects'].firstLetterToLowerCase()
          "
          type="switch"
          v-model="sendAllProjects"
        />
        <BaseInput
          v-if="type === 'projects' && !sendAllProjects"
          :label="t.main['projects']"
          v-model="project"
          :items="projectList"
          type="autocomplete"
          item-value="id"
          :item-text="(i) => i.name"
          multiple
          small-chips
          deletable-chips
          :view="modalType === 'show'"
          :rules="['required']"
        >
          <template v-slot:viewValue>
            <div v-if="project.length">
              <v-btn
                v-for="item in projectList"
                color="#277faf"
                rounded
                small
                depressed
                dark
                :to="{ name: 'ProjectsProjectShow', params: { id: item.id } }"
                class="mr-1 mb-1 f12 text-none"
                :key="item.id"
              >
                {{ item.name }}
              </v-btn>
            </div>
          </template>
        </BaseInput>
        <BaseInput
          v-if="type !== 'projects'"
          v-model="whom"
          :items="whomList"
          item-value="value"
          item-text="text"
          :label="t.main['whom']"
          type="select"
          :view="modalType === 'show'"
          :view-value="whomList.find((i) => i.value === whom).text"
        />
        <BaseInput
          v-else-if="modalType !== 'show'"
          :label="t.main['extra_whom']"
          type="switch"
          v-model="whom_extra"
        />
        <BaseInput
          v-if="type === 'projects' ? whom_extra : whom === 'selectively'"
          v-model="recipients"
          :items="commonUserGridAll"
          item-value="id"
          :item-text="(i) => i.first_name + ' ' + i.last_name"
          :label="t.main['recipients']"
          multiple
          type="autocomplete"
          small-chips
          deletable-chips
          :view="modalType === 'show'"
          :rules="['requiredArray']"
        >
          <template slot="viewValue" v-if="itemData">
            <div class="list">
              <div
                class="chip f12"
                v-for="(recipient, key) in itemData.recipients"
                :key="'recipient_' + key"
              >
                {{ recipient.first_name + ' ' + recipient.last_name }}
              </div>
            </div>
          </template>
        </BaseInput>
        <template v-if="modalType === 'show'">
          <BaseInput
            :label="t.main['successful_count']"
            view
            :view-value="itemData.successful_count.toString()"
          />
        </template>
      </div>
      <div class="form_wrap-col">
        <BaseInput
          v-if="type === 'triggered' || type === 'projects'"
          v-model="trig"
          :items="triggersList"
          item-value="value"
          item-text="text"
          type="select"
          :label="t.main['trigger']"
          :view="modalType === 'show'"
          :view-value="
            trig &&
            (type === 'projects'
              ? notificationAdminProjectTriggersList &&
                notificationAdminProjectTriggersList.find((i) => i.value === trig).text
              : notificationAdminProjectTriggersList &&
                notificationAdminTriggeredTriggersList.find((i) => i.value === trig).text)
          "
          :rules="['required']"
        />
        <BaseInput
          v-model="pushType"
          :items="pushTypeList"
          item-value="value"
          item-text="text"
          type="select"
          :label="t.main['type']"
          :view="modalType === 'show'"
          :view-value="pushTypeList && pushTypeList.find((i) => i.value === pushType).text"
          :disabled="type === 'triggered' && trig === 'client_bill_signed'"
        />
        <BaseInput
          v-if="
            (pushType === 'once' || (modalType === 'show' && pushType !== 'repeating')) &&
            trig !== 'client_bill_signed'
          "
          v-model="send_at"
          :label="t.main[type === 'manual' ? 'send_at' : 'time_send']"
          :type="type === 'manual' ? 'datetime-picker' : 'time-picker'"
          :view="modalType === 'show'"
          :view-value="
            modalType === 'show' &&
            (pushType === 'immediate'
              ? $formatDate(itemData.created_at)
              : pushType === 'delayed'
              ? $formatDate(
                  new Date(
                    new Date(itemData.created_at).getTime() + itemData.schedule.delay * 60000,
                  ).toISOString(),
                )
              : pushType === 'once'
              ? $formatDate(itemData.schedule.send_at)
              : $formatDate(itemData.created_at))
          "
          :dateMin="dateNow"
          :rules="['required']"
        />
        <BaseInput
          v-if="pushType === 'repeating'"
          v-model="start_at"
          :label="t.main[type === 'manual' ? 'start_at' : 'time_start']"
          :type="type === 'manual' ? 'datetime-picker' : 'time-picker'"
          :view="modalType === 'show'"
          :view-value="start_at ? $formatDate(start_at) : '-'"
          :dateMin="dateNow"
          :rules="['required']"
        />
        <BaseInput
          v-if="
            (type === 'manual' || type === 'projects') &&
            (pushType === 'delayed' || pushType === 'repeating')
          "
          v-model="delay"
          :label="t.main['delay']"
          :items="pushType === 'repeating' ? delayList : numberList"
          :item-value="(i) => (i.value === 0 ? 0 : 0 || i)"
          :item-text="(i) => i.text || i"
          type="autocomplete"
          :view="modalType === 'show'"
          :view-value="
            delay === 0 ? localStorage.translations.pages['common'].text['no_delay'] : delay
          "
          :rules="['required']"
        />
        <BaseInput
          v-if="pushType === 'repeating'"
          v-model="repeats"
          :label="t.main['repeats']"
          :items="repeatsList"
          :item-value="(i) => i.value || i"
          :item-text="(i) => i.text || i"
          type="autocomplete"
          :view="modalType === 'show'"
          :view-value="
            repeats === -1 ? localStorage.translations.pages['common'].text['no_limits'] : repeats
          "
          :rules="[repeats !== -1 ? 'required' : null]"
        />
        <BaseInput
          v-if="pushType === 'repeating'"
          v-model="interval"
          :label="t.main['interval']"
          :items="numberList"
          type="autocomplete"
          :view="modalType === 'show'"
          :rules="['required']"
        />
        <BaseInput
          v-if="pushType === 'repeating' && trig !== 'client_bill_signed'"
          v-model="until"
          :label="t.main[type === 'manual' ? 'date_end' : 'time_end']"
          :type="type === 'manual' ? 'datetime-picker' : 'time-picker'"
          :view="modalType === 'show' || repeats !== -1"
          :view-value="
            modalType === 'show'
              ? itemData.until
                ? $formatDate(itemData.until)
                : itemData.schedule.repeats > 0
                ? calculationUntil({
                    start_at: itemData.schedule.start_at,
                    delay: itemData.schedule.delay,
                    interval: itemData.schedule.interval,
                    repeats: itemData.schedule.repeats,
                  })
                : '-'
              : start_at && repeats > 0 && interval && delay >= 0
              ? calculationUntil({ start_at, delay, interval, repeats })
              : '-'
          "
          :dateMin="
            (start_at ? new Date(start_at) : new Date()).toLocaleString('sv-SE', {
              timeZone: 'Europe/Helsinki',
            })
          "
          :timeMin="start_at"
          :rules="['required']"
        />
        <BaseInput
          v-if="type === 'triggered' || this.type === 'projects' ? true : modalType !== 'create'"
          v-model="is_active"
          :label="t.statuses.in_progress"
          type="switch"
          :view="modalType === 'show'"
          :rules="['required']"
        >
          <template v-slot:viewValue>
            <div :style="'color: ' + (is_active ? '#219653' : '#EB5757') + ';'">
              {{ is_active ? '✔' : '✘' }}
            </div>
          </template>
        </BaseInput>
      </div>
    </div>
  </TemplateModal>
</template>

<script>
// import UsersListItem from 'components/setting/users/UsersListItem'
import TemplateModal from 'components/templates/TemplateModal'
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import BaseInput from 'components/base/BaseInput'

export default {
  name: 'SettingsPushNotificationsModal',
  props: {
    onDownloadPageData: Function,
    itemData: Object,
    type: {
      type: String,
      default: 'manual',
    },
    modalType: String,
  },
  components: {
    BaseInput,
    TemplateModal,
  },
  data: () => ({
    dialog: false,
    title: '',
    body: '',
    recipients: [],
    project: [],
    pushType: 'once',
    sendAllProjects: true,
    data: {
      dates: [],
    },
    whom: 'all',
    whom_extra: false,
    //разово
    send_at: null,

    //для задержки
    delay: null,

    //Для повторений
    start_at: null,
    interval: null,
    repeats: null,
    until: null,

    is_active: true,
    trig: null,
  }),
  watch: {
    modalStatus() {
      if (this.modalStatus) {
        this.onCommonUserGridAll()
        this.checkReadyData()
        if (this.type === 'triggered' || this.type === 'projects') {
          this.onNotificationAdminTriggeredTypes()
          // if (this.type === 'projects' && this.modalType === 'create') {
          //   this.trig = 'project_ending'
          // }
        } else {
          this.onNotificationAdminManualTypes()
        }
      }
    },
    '$route.name'() {
      this.trig = null
    },
    type() {
      this.send_at = null
      this.start_at = null
      this.interval = null
      this.repeats = null
      this.until = null
    },
    whom() {
      if (this.type !== 'projects') {
        if (this.whom === 'selectively') {
          this.recipients = this.itemData
            ? this.itemData.recipients_group === 'all'
              ? []
              : this.itemData.recipients.map((i) => i.id)
            : []
        } else if (this.whom === 'all') {
          this.recipients = []
        }
      }
    },
    whom_extra() {
      if (this.type === 'projects') {
        this.recipients = this.whom_extra
          ? this.itemData.extra_recipients.length && this.itemData.extra_recipients.map((i) => i.id)
          : []
      }
    },
    trig(newValue, oldValue) {
      if (newValue === 'client_bill_signed') {
        this.pushType = 'immediate'
      }
      if (oldValue === 'client_bill_signed') {
        this.pushType = 'once'
      }
      if (oldValue && oldValue !== newValue && this.type === 'projects') {
        // let regex = new RegExp('[EMPLOYEES]', 'g')
        this.title = this.title.replace(/ *\[[^\]]*]/g, '')
        this.body = this.body.replace(/ *\[[^\]]*]/g, '')
      }
    },
  },
  computed: {
    ...mapGetters(['apiDomain', 'inputRules']),
    ...mapGetters('commonUser', ['commonUserGridAll']),
    ...mapGetters('notificationAdminTriggered', ['notificationAdminTriggeredTriggersList']),
    ...mapGetters('notificationAdminProject', [
      'notificationAdminProjectTriggersList',
      'notificationAdminProjectProjectsList',
    ]),
    ...mapState('notificationAdminManual', ['notificationAdminManualTypes']),
    ...mapState('notificationAdminTriggered', ['notificationAdminTriggeredTypes']),
    ...mapGetters('workClientProject', ['workClientProjectAllInWork']),
    t() {
      return this.localStorage.translations.pages['setting-push_notifications']
    },
    modalStatus() {
      return this.$refs.modal && this.$refs.modal.dialog
    },
    pushTypeList() {
      const list = [
        {
          value: 'immediate',
          text: this.t.types['immediate'],
        },
        {
          value: 'delayed',
          text: this.t.types['delayed'],
        },
        {
          value: 'once',
          text: this.t.types['once'],
        },
        {
          value: 'repeating',
          text: this.t.types['repeating'],
        },
      ]
      return this.type === 'triggered'
        ? list.filter(
            (i) =>
              (this.trig === 'client_bill_signed' ? i : i.value !== 'immediate') &&
              i.value !== 'delayed',
          )
        : list
    },
    triggersList() {
      let data = []
      let list =
        this.type === 'projects'
          ? this.notificationAdminProjectTriggersList
          : this.notificationAdminTriggeredTriggersList
      for (let trigger of list) {
        let obj = {
          value: trigger.value,
        }
        const transitionTarget = this.t.triggers[trigger.value]
        if (transitionTarget) {
          obj.text = transitionTarget
        } else {
          obj.text = trigger.text
        }
        data.push(obj)
      }
      return data
    },
    projectList() {
      if (this.notificationAdminProjectProjectsList)
        return this.notificationAdminProjectProjectsList
      return []
    },
    whomList() {
      return [
        {
          value: 'all',
          text: this.localStorage.translations.pages['common'].text['everyone'],
        },
        {
          value: 'selectively',
          text: this.localStorage.translations.pages['common'].text['selectively'],
        },
      ]
    },
    dateNow() {
      return new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Helsinki' })
    },
    numberList() {
      let array = []
      for (let number = 1; number <= 1000; number++) {
        array.push(number)
      }
      return array
    },
    repeatsList() {
      const array = [
        {
          text: this.localStorage.translations.pages['common'].text['no_limits'],
          value: -1,
        },
      ]
      return array.concat(this.numberList)
    },
    delayList() {
      const array = [
        {
          text: this.localStorage.translations.pages['common'].text['no_delay'],
          value: 0,
        },
      ]
      return array.concat(this.numberList)
    },
    projectVariableList() {
      let defaultList = [
        {
          value: '[PROJECT]',
          text: this.localStorage.translations.pages.sales_project['project_client-labels'][
            'nazvanie-proekta'
          ],
        },
        {
          value: '[MANAGER]',
          text: this.localStorage.translations.pages.sales_project['planned_resources-labels'][
            'rukovoditel-proekta'
          ],
        },
      ]
      let presenceEndingList = [
        {
          value: '[EMPLOYEES]',
          text: this.localStorage.translations.pages.finance['period-table']['employee'],
        },
        {
          value: '[WORK_TYPES]',
          text: this.localStorage.translations.pages.sales_project['planned_resources-labels'][
            'vid-raboty'
          ],
        },
        {
          value: '[END_DATE]',
          text: this.localStorage.translations.pages.sales_project['planned_resources-labels'][
            'data-kontsa'
          ],
        },
      ]
      return this.itemData && this.itemData.trigger === 'project_presence_ending'
        ? [...defaultList, ...presenceEndingList]
        : defaultList
    },
  },
  methods: {
    ...mapActions('notificationAdminManual', [
      'onNotificationAdminManualGrid',
      'onNotificationAdminManualCreate',
      'onNotificationAdminManualUpdate',
      'onNotificationAdminManualTypes',
    ]),
    ...mapActions('notificationAdminTriggered', [
      'onNotificationAdminTriggeredCreate',
      'onNotificationAdminTriggeredUpdate',
      'onNotificationAdminTriggeredProcessActivation',
      'onNotificationAdminTriggeredTypes',
    ]),
    ...mapActions('notificationAdminProject', [
      'onNotificationAdminProjectCreate',
      'onNotificationAdminProjectUpdate',
    ]),
    ...mapActions('commonUser', ['onCommonUserGridAll']),
    async checkReadyData() {
      if (this.itemData) {
        this.is_active = this.itemData.is_active
        this.title = this.itemData.title
        this.body = this.itemData.body
        this.pushType = this.itemData.schedule.type
        this.whom = this.itemData.recipients_group === 'all' ? 'all' : 'selectively'
        this.recipients = this.itemData.extra_recipients
          ? this.itemData.extra_recipients.length
            ? this.itemData.extra_recipients.map((i) => i.id)
            : []
          : this.itemData.recipients_group === 'all'
          ? []
          : this.itemData.recipients && this.itemData.recipients.length
          ? this.itemData.recipients.map((i) => i.id)
          : []
        if (this.recipients.length && this.type === 'projects') this.whom_extra = true
        if (this.itemData['trigger']) {
          this.trig = this.itemData['trigger']
        }
        if (this.itemData.projects_group) {
          this.sendAllProjects = true
        }
        if (this.itemData['work_client_projects'] && this.itemData['work_client_projects'].length) {
          this.project = this.itemData['work_client_projects'].map((i) => i.id)
        }
        if (this.pushType === 'once') {
          this.send_at = this.itemData.schedule.send_at
        } else if (this.pushType === 'delayed') {
          this.delay = this.itemData.schedule.delay
        } else if (this.pushType === 'repeating') {
          this.delay = this.itemData.schedule.delay
          this.start_at = this.itemData.schedule.start_at
          this.interval = this.itemData.schedule.interval
          this.repeats = this.itemData.schedule.repeats
          this.until = this.itemData.schedule.until
        }
      }
    },
    defaultData() {
      this.data = {
        dates: [],
        send_at: null,

        //для задержки
        delay: null,

        //Для повторений
        start_at: null,
        interval: null,
        repeats: null,
        until: null,
        is_active: true,
        trigger: null,
      }
    },
    calculationUntil({ start_at, delay, interval, repeats }) {
      let result = this.$formatDate(
        new Date(
          new Date(this.type !== 'manual' ? '2022-02-22 ' + start_at : start_at).getTime() +
            (delay ? delay * 60000 : 0) +
            interval * repeats * 60000,
        ).toISOString(),
      )
      if (this.type !== 'manual') {
        let [date, time] = result.split(' ')
        result = date == '22.02.2022' ? time : '23:59'
      }
      return result
    },
    onCreatePush() {
      console.log('onCreatePush')
      if (this.$refs.modal.validate()) {
        let data = {
          title: this.title,
          body: this.body,
          is_active: this.is_active,
          schedule: {},
        }
        if (this.type === 'projects')
          data.extra_recipients = this.recipients && this.recipients.length ? this.recipients : []
        else {
          data.recipients = this.recipients.length ? this.recipients : null
          data.recipients_group = this.whom === 'all' ? 'all' : null
        }
        if (this.type === 'triggered' || this.type === 'projects') {
          data.trigger = this.trig
        }
        if (this.pushType === 'once') {
          data.schedule = {
            type: this.pushType,
            send_at: this.send_at,
          }
        } else if (this.pushType === 'delayed') {
          data.schedule = {
            type: this.pushType,
            delay: this.delay,
          }
        } else if (this.pushType === 'repeating') {
          data.schedule = {
            type: this.pushType,
            delay: this.type === 'triggered' || this.type === 'projects' ? 0 : this.delay,
            start_at: this.start_at,
            interval: this.interval,
            repeats: this.repeats,
            until: this.until,
          }
        } else if (this.pushType === 'immediate') {
          data.schedule = {
            type: this.pushType,
          }
        }
        if (!this.sendAllProjects) {
          if (this.project && this.project.length) {
            data.work_client_projects = this.project
          }
        } else {
          data.work_client_projects = null
          data.projects_group = 'in_progress'
        }
        ;(this.type === 'manual'
          ? this.modalType === 'create'
            ? this.onNotificationAdminManualCreate({ data })
            : this.onNotificationAdminManualUpdate({ id: this.itemData.id, data })
          : this.type === 'projects'
          ? this.modalType === 'create'
            ? this.onNotificationAdminProjectCreate({ data })
            : this.onNotificationAdminProjectUpdate({ id: this.itemData.id, data })
          : this.modalType === 'create'
          ? this.onNotificationAdminTriggeredCreate({ data })
          : this.onNotificationAdminTriggeredUpdate({ id: this.itemData.id, data })
        )
          .then((resp) => {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },
              { root: true },
            )
            this.onDownloadPageData()
            this.$refs.modal.closeModal()
            this.onClearDataInputs()
            if (
              this.type === 'triggered' &&
              this.trig !== 'client_bill_signed' &&
              new Date(resp.data.data.created_at)
                .toLocaleString('sv-SE', { timeZone: 'Europe/Helsinki' })
                .split(' ')[1] <
                resp.data.data.schedule[this.pushType === 'once' ? 'send_at' : 'start_at']
            ) {
              this.onNotificationAdminTriggeredProcessActivation()
            }
          })
          .catch((err) => {
            console.log(err)
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['oshibka'] +
                  ' ' +
                  err.response.data.message,
                IsError: true,
              },
              { root: true },
            )
          })
      }
    },
    onClearDataInputs() {
      this.title = ''
      this.body = ''
      this.recipients = []
      this.project = []
      this.pushType = 'once'
      this.send_at = null
      this.delay = null
      this.start_at = null
      this.interval = null
      this.until = null
    },
    onAddVariable({ type, value }) {
      this[type] += value
    },
    // onDeleteVariableInText(valueName) {
    //   const findProjectIndex = this[valueName].indexOf('[PROJECT')
    //   console.log('findProjectIndex', findProjectIndex)

    //   if (findProjectIndex > -1) {
    //     // this[valueName] = this[valueName].replace('[PROJECT', '')
    //     this[valueName] = this[valueName].replace(/\[PROJECT/i,'')
    //   }
    //   const findManagerIndex =
    //     this[valueName].indexOf('[MANAGER') && !this[valueName].indexOf('[MANAGER]')
    //   if (findManagerIndex) {
    //     this[valueName] = this[valueName].replace('[MANAGER ', '')
    //   }
    // },
  },
}
</script>

<style lang="scss" scoped>
.form_wrap {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(375px, 400px));
  gap: 30px;

  &-col {
    display: grid;
    height: max-content;
    gap: 20px;
  }
}

.list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
}

.chip {
  border: 1px solid #bedbeb;
  width: max-content;
  padding: 8px;
  border-radius: 4px;
  color: #2c2c2c;
  height: max-content;
  // cursor: pointer;
  overflow: hidden;
  width: 100%;
  display: grid;
  gap: 10px;
  white-space: nowrap;
  max-width: max-content;
  border: none;
  background-color: #277faf;
  color: #ffffff;

  span {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}

:deep() .base-input {
  max-width: 400px !important;
}
.list-item {
  display: block;
  padding: 10px;
  transition: 0.3s;
  cursor: pointer;
  &:hover {
    background: #277faf;
    color: #ffffff;
  }
}
</style>
